import toast from 'react-hot-toast';
import { parsePhoneNumber } from 'react-phone-number-input';
import { getRequest, postRequest } from '../../../api/api';

const notifyError = (message) => {
    toast.error(message, {
        duration: 5000,
    });
};

const client_id_secret = {
    client_id: process.env.REACT_APP_CLIENT_ID,
    client_secret: process.env.REACT_APP_CLIENT_SECRET,
};

export function postSignUp(values, callbackResponse, callbackError) {
    var requestData = { ...values };

    const parsedPhoneNumber = parsePhoneNumber(requestData.phone_no);
    requestData.phone_no = parsedPhoneNumber?.nationalNumber;
    requestData.country_code = parsedPhoneNumber?.countryCallingCode;
    requestData.identification_type_id = /^[A-Z0-9]{6,12}$/.test(
        requestData.identification_no
    )
        ? 2
        : 1;

    postRequest(
        'api/v1/register/account-setup',
        null,
        requestData,
        callbackResponse,
        callbackError
    );
}

export function postRetrievePersonalInformation(callbackResponse) {
    const requestData = {
        registration_id: localStorage.getItem('registration_id')
    }

    return postRequest(
        'api/v1/register/retrieve-registration',
        null,
        requestData,
        callbackResponse
    )
}

export function getRegistrationDropdownList(callbackResponse) {
    return getRequest(
        'api/v1/register/registration-options?locale=' + localStorage.getItem('language'),
        null,
        callbackResponse
    );
}

export const postSubmitPersonalInformation = (values, callbackResponse) => {
    const requestData = {
        ...values,
        registration_id: localStorage.getItem('registration_id')
    };

    postRequest(
        'api/v1/register/personal-info',
        null,
        requestData,
        callbackResponse
    );
};

export function getThaIDVerification(callBackResponse) {
    return getRequest(
        'api/v1/dopa/initiate',
        { registration_id: localStorage.getItem('registration_id') },
        callBackResponse,
    );
};

export const postSubmitPersonalDocuments = (values, callbackResponse) => {
    const requestData = {
        ...values,
        registration_id: localStorage.getItem('registration_id')
    }

    postRequest(
        'api/v1/register/personal-documents',
        null,
        requestData,
        callbackResponse
    )
}

export const postSubmitPersonalVideo = (values, callbackResponse) => {
    const requestData = {
        ...values,
        // ...client_id_secret,
        registration_id: localStorage.getItem('registration_id')
    }

    postRequest(
        'api/v1/register/video-verification',
        null,
        requestData,
        callbackResponse
    )
}

export const postSubmitVerifyMobile = (values, callbackResponse) => {
    const requestData = {
        ...values,
        registration_id: localStorage.getItem('registration_id')
    }

    postRequest(
        'api/v1/register/verify-mobile',
        null,
        requestData,
        callbackResponse
    )
}